import { Grid } from '@mui/material'
import React, { useContext } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";
import TabComponent from '../../../../../components/global/tabComponent';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { manualAgentData } from '../../../../../models/axiosModel';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../../../context/dataConnectorContext';
import SmartAssist from '../smartAssist';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import InfoTabContent from './infoTabContent';
import AgentDataTabContent from './agentDataTabContent';
import InfoTabSkeleton from './infoTabSkeleton';
import AgentDataTabSkeleton from './agentDataTabSkeleton';

interface InfoPanelProps {
    onRemoveAgent: (e: any, agent: manualAgentData) => void,
}

const renderNoInfoAvailableBlock = (text: string) => {
    return (
        <div className={clsx(globalStyles.primaryFontSize, globalStyles.secondaryFontWeight, globalStyles.displayFlexStyle, globalStyles.justifyCenter, globalStyles.alignItemCenter)}>
            {text}
        </div>
    );
}

const InfoPanel = (props: InfoPanelProps) => {
    const { onRemoveAgent } = props
    const { handleError } = useContext(UserContext) as UserContextPayload
    const { smartAssistToolList, getChatbotDataConnectorList, setFilteredDataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;

    const { threadInfoTabValue, setThreadInfoTabValue, isInfoTabLoading } = useRuleBasedInboxStore(useShallow((state) => ({
        threadInfoTabValue: state.threadInfoTabValue,
        setThreadInfoTabValue: state.setThreadInfoTabValue,
        isInfoTabLoading: state.isInfoTabLoading,
    })))

    const getChatbotDataConnectorListApiCall = async () => {
        const res = await getChatbotDataConnectorList(true);
        if (!(res.status)) {
            handleError(res);
        }
    }

    const onTabChangeOfInformationBlock = (tab: {label: string;}) => {
        if (tab.label == "Smart Assist") {
            if(smartAssistToolList){
                setFilteredDataConnectorList(smartAssistToolList);
            } else {
                getChatbotDataConnectorListApiCall();
            }
        }
    }

    return (
        <Grid container direction={"column"} gap={"6px"} padding={"8px 6px 8px 16px"} className={clsx(globalStyles.fullwidth, globalStyles.maxWidthFull, globalStyles.spaceAlignmentCenter)}>
            <TabComponent
                value={threadInfoTabValue}
                setValue={setThreadInfoTabValue}
                onTabChange={(tab) => onTabChangeOfInformationBlock(tab)}
                tabHeaderClassname="settingsTabStyle" className="" tabs={
                    [
                        {
                            label: 'Info',
                            content: isInfoTabLoading
                                ? <InfoTabSkeleton />
                                : <InfoTabContent renderNoInfoAvailableBlock={renderNoInfoAvailableBlock} />,
                            tabVisibility: true,
                            flagInitiallyActive: false
                        },
                        {
                            label: 'Smart Assist',
                            content: <SmartAssist renderNoInfoAvailableBlock={renderNoInfoAvailableBlock} />,
                            tabVisibility: true,
                            flagInitiallyActive: false
                        },
                        {
                            label: "Agent Data",
                            content: isInfoTabLoading
                                ? <AgentDataTabSkeleton />
                                : <AgentDataTabContent onRemoveAgent={onRemoveAgent} renderNoInfoAvailableBlock={renderNoInfoAvailableBlock} />,
                            tabVisibility: true,
                            flagInitiallyActive: false
                        }
                    ]
                }
            />
        </Grid>
    )
}

export default React.memo(InfoPanel)
